<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'department', 'com_name', 'writer_name', 'date']" />
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t("공지사항") }}</h5>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t("교육일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.교육일 }}</p>
          <date-selector v-else v-model="form.교육일" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("교육기간") }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.교육기간.sDate }} ~ {{ form.교육기간.sDate }}</p>
          <date-selector-rang v-else :readonly="board.readonly" class="flex" v-model="form.교육기간" />
        </div>
        <div>
          <div>{{ $t("교육장소") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.교육장소 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.교육장소" :readonly="board.readonly" />
        </div>
      </div>

      <h5 class="my-4"><i class="dot"></i>{{ $t("교육내용") }}</h5>
      <div>
        <div v-if="isPrint" class="print-textarea">{{ form.교육내용 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.교육내용" :readonly="board.readonly" />
      </div>

      <!--    사진대지-->
      <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" :section-title="$t('위험성평가 교육 실시사진')"  :placeholder="$t('위험성평가 교육 실시사진')" />

      <AttendeeTableTwoColumn v-model="form.참석자명단" :board="board" :is-print="isPrint" class="mt-28px" :title="$t('참석자 명단')" />

      <file-upload-module v-if="!isPrint" v-model="form.fileList" class="w-full" :isPrint="isPrint" :readonly="board.readonly" />
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import AttendeeTableTwoColumn from "@/components/AttendeeTableTwoColumn.vue";

export default {
  components: {
    AttendeeTableTwoColumn,
    DateSelectorRang,
    RadioGroup,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {},
  data() {
    return {
      form: {
        stdInfo: {},
        교육일: "",
        교육기간: {},
        교육장소: "",
        교육내용:
          "(예시) 위험성 감소대책 실시 후 남아있는 유해·위험요인 개선을 위한 브레인스토밍\n" +
          "(예시) 위험성 감소대책 도입 시 현장의 애로사항 공유\n" +
          "(예시) 위험성 감소대책 모니터링 담당자 지정 및 유해·위험요인 개선 확인을 위한 현장점검 결과 공유\n" +
          "(예시) 업체별 혼재작업 발생 시 작업공정 조정 등의 안전조치사항 및 비상연락망 안내\n" +
          "(예시) 작업장 순회점검, 안전보건협의체 등 주기적인 유해·위험요인 개선을 위한 안전 및 보건조치 일정 공유\n" +
          "(예시) 작업 전 필수적으로 확인할 안전조치사항 및 작업 시 주의사항 공유 등",
        참석자명단: [],

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    isMobile() {
      return this.$store.state.windowWidth <= 768;
    },
  },
};
</script>
